

















































import { Vue, Component, Prop } from "vue-property-decorator"

@Component
export default class SStatusBox extends Vue {
    @Prop({ default: 0 }) activated!: number
    @Prop({ default: 0 }) deactivated!: number
    @Prop({ default: 0 }) updated!: number

    @Prop() activatedSubtitle!: string
    @Prop() deactivatedSubtitle!: string
    @Prop() updatedSubtitle!: string
}
